import { APIParser } from './api-parser';
import { NEW_API_URL } from './api-client';
import { createURLWithQueryParams, createFetchGetOptions } from './api-util';

const baseDashboardURL = `${NEW_API_URL}dashboard/`;
const baseDashboardDynamicFieldsURL = `${baseDashboardURL}dynamic-fields/`;
const baseDashboardDynamicFieldsURL_NEW = `${baseDashboardURL}tech/getdynamicfields/`;
const carryOverDynamicFieldsURL = `${baseDashboardURL}tech/carryoverdashboarddata/`;

/** interface DashboardDynamicFieldsRequestDto {
 *      FieldType:  string
 *      StartDate:  Date
 *      EndDate:    Date
 *  }
 */
// This endpoint includes Tech CarryOver. Lower performance.
export const getDashboardDynamicFields = async (dashboardDynamicFieldsRequestDto) => {
    const url = createURLWithQueryParams(
        baseDashboardDynamicFieldsURL,
        dashboardDynamicFieldsRequestDto
    );

    const response = await fetch(url, createFetchGetOptions());

    var data = await APIParser(response);

    if (data.status === "dashboardNotAuthorized") {
        console.log(data.message);
        return null;
    }
    return data;
};

// This endpoint doesn't includes Tech CarryOver. Higher performance.
export const getDashboardDynamicFieldsNEW = async (dashboardDynamicFieldsRequestDto) => {
    const url = createURLWithQueryParams(
        baseDashboardDynamicFieldsURL_NEW,
        dashboardDynamicFieldsRequestDto
    );

    const response = await fetch(url, createFetchGetOptions());

    var data = await APIParser(response);

    if (data.status === "dashboardNotAuthorized") {
        console.log(data.message);
        return null;
    }
    return data;
};

export const getDashboardCarryOverDynamicFields = async (dashboardDynamicFieldsRequestDto) => {
    const carryOverUrl = createURLWithQueryParams(
        carryOverDynamicFieldsURL,
        dashboardDynamicFieldsRequestDto
    );

    const carryOverResponse = await fetch(carryOverUrl, createFetchGetOptions());
    const carryOverData = await APIParser(carryOverResponse);

    if (carryOverData.status === "dashboardNotAuthorized") {
        console.log(carryOverData.message);
        return null;
    }

    const dashboardUrl = createURLWithQueryParams(
        baseDashboardDynamicFieldsURL_NEW,
        dashboardDynamicFieldsRequestDto
    );

    const dashboardResponse = await fetch(dashboardUrl, createFetchGetOptions());
    const dashboardData = await APIParser(dashboardResponse);

    if (dashboardData.status === "dashboardNotAuthorized") {
        console.log(dashboardData.message);
        return null;
    }

    return dashboardData;
};

export const getDashboardCarryOver = async() => {
    const carryOverResponse = await fetch(carryOverDynamicFieldsURL, createFetchGetOptions());
    const carryOverData = await APIParser(carryOverResponse);

    if (carryOverData.status === "dashboardNotAuthorized") {
        console.log(carryOverData.message);
        return null;
    }

    return carryOverData;
}
